import { Check } from 'lucide-react'
import { cn } from '@/utils'

export type TrayPlacedBadgePlacement = 'inside' | 'overlap-bottom'

/**
 * The "Placed" badge pinned to a tray thumbnail's bottom-left corner (Photos, ClikArt,
 * Backgrounds). Decorative: the host puts "placed" in its own accessible name where it matters.
 * The positioned parent must be `position: relative`. `'inside'` (default) sits 8px above the
 * parent's bottom edge; `'overlap-bottom'` is centred on that edge (WMPCM-13312), so the parent
 * must not clip its overflow.
 */
export function TrayPlacedBadge({
  placement = 'inside',
}: {
  placement?: TrayPlacedBadgePlacement
}) {
  return (
    <span
      className={cn(
        'absolute left-2 z-[5] flex h-5 items-center gap-1',
        placement === 'overlap-bottom' ? 'bottom-0 translate-y-1/2' : 'bottom-2',
        'rounded-lg border border-[#E5E5E5] bg-white px-2 py-0.5',
        'text-xs font-semibold leading-4 text-[#1E1902] pointer-events-none'
      )}
      aria-hidden="true"
    >
      <Check className="h-3 w-3 shrink-0" strokeWidth={1.25} aria-hidden="true" />
      Placed
    </span>
  )
}
